import { TransactionDto } from "@/application/dtos/app/transactions/TransactionDto";
import { ApiService, ApiServiceType } from "../../ApiService";

export class TransactionService {
  api: ApiService;
  constructor() {
    this.api = new ApiService("Transaction", ApiServiceType.TenantDatabase);
  }
  adminGetAll(): Promise<TransactionDto[]> {
    return this.api.getAll("Admin/GetAll");
  }
  getAll(): Promise<TransactionDto[]> {
    return this.api.getAll();
  }
  get(id: string): Promise<TransactionDto> {
    return this.api.get("Get", id);
  }
  create(data: TransactionDto): Promise<TransactionDto> {
    return this.api.post(data);
  }
  update(id: string, data: TransactionDto): Promise<TransactionDto> {
    return this.api.put(id, data);
  }
  delete(id: string): Promise<any> {
    return this.api.delete(id);
  }
  adminDelete(id: string): Promise<any> {
    return this.api.delete(id, "Admin/Delete");
  }
}
